import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

function CardSkeleton() {
  return (
    <div className="card h-100 shadow">
      <div className="card-header border-0 pt-9 d-flex justify-content-between align-items-center">
        <Skeleton circle height={30} width={30} />
        <Skeleton width={80} height={20} />
      </div>

      <div className="card-body d-flex flex-column px-9 pt-6 pb-8">
        <Skeleton width="60%" height={30} className="mb-4" />

        <div className="mb-3">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="d-flex align-items-center mb-2">
              <Skeleton circle height={10} width={10} className="me-2" />
              <Skeleton width="80%" height={15} />
            </div>
          ))}
        </div>

        <div className="d-flex flex-wrap justify-content-around align-items-center mb-3">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="text-center">
              <Skeleton width={100} height={60} />
            </div>
          ))}
        </div>

        <div className="d-flex flex-column">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="d-flex justify-content-between mb-2">
              <Skeleton width="40%" height={20} />
              <Skeleton width={30} height={20} />
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-center mt-10">
          <Skeleton width={100} height={40} />
        </div>
      </div>
    </div>
  )
}

function SubscriptionSkeleton() {
  return (
    <div className="d-flex flex-wrap justify-content-center gap-4">
      {Array.from({ length: 6 }).map((_, index) => (
        <div key={index} style={{ width: '30%' }}>
          <CardSkeleton />
        </div>
      ))}
    </div>
  )
}

export default SubscriptionSkeleton
